<template>
  <span class="invalid-feedback" v-if="haveErrorMessage">
    {{ errorMessage }}.
  </span>
</template>

<script>
import { trimEnd } from 'lodash'
export default {
  inject: ['$validator'],

  name: 'help-block',

  props: {
    field: {
      type: String,
      required: true
    },
    scope: {
      type: String,
      required: false
    }
  },

  computed: {
    haveErrorMessage () {
      return this.errors.has(this.field, this.scope)
    },

    errorMessage () {
      return trimEnd(this.errors.first(this.field, this.scope), '.')
    }
  }
}
</script>
